import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import Button from '@r1-frontend/ui-react/components/buttons/button';
// @ts-ignore
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BaseSpeedLine } from '@r1-frontend/ui-react/organisms/SpeedLine';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { RequestFormPhone } from '~/src/components/RequestFormPhone';

import { breakePoints } from '~/src/features/internet/internet-represent/styled';

const breakPoints = {
    tablet: '1023px',
};

export const StyledContainer = styled(GridContainer)`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;

    @media (max-width: ${breakePoints.desktop}) {
        padding-left: 0;
        padding-right: 0;
    }

     @media (max-width: ${breakePoints.mobile}) {
        padding-left: 16px;
        padding-right: 16px;
    }
`;

export const SRequestFormPhone = styled(RequestFormPhone)<{isMobile: boolean}>`
    padding: 0;
    padding: ${p => p.isMobile ? '15px' : '24px'};
    background-color: ${COLORS.GRAY_XS};
    border-radius: ${BorderRadius.OuterBlockRadius};

    input[type="checkbox"] {
        align-self: flex-start;
    }

    > div > div {
        > button {
           @media (max-width: ${breakPoints.tablet}) {
               width: 100%;
           }
        }
    }
`;

export const RepresentTop = styled.div`
    width: 100%;
    padding: 30px 0 0 0;

    @media (max-width: ${breakePoints.mobile}) {
        margin-bottom: 20px;
    }
`;

export const BlockWithSpeedLineWrapper = styled.div`
    width: 100%;

    @media (min-width: ${wideBreakpoints.mobile}) {
        margin-top: 160px;
    }
`;
export const SpeedLineSelectorWrapper = styled.div`
    display: flex;
    flex-direction: row;
    
    gap: 12px;
    
    & > * {
        width: 100%;
    }
`;

export const SBaseSpeedLine = styled(BaseSpeedLine)`
    margin-top: 12px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-top: 8px;
    }
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    
    gap: 12px;
    
    ${Button}:first-child {
        flex-grow: 1;
    }

    ${Button}:last-child {
        align-self: flex-end;
    }
    
    @media (min-width: ${wideBreakpoints.mobile}) {
        margin-top: 12px;
    }
`;

export const Content = styled.div`
    display: flex;
    flex-wrap: nowrap;
    width: 100%;

    @media (max-width: ${breakePoints.mobile}) {
        flex-direction: column;
        row-gap: 40px;
    }
`;

export const TextContent = styled.div`
    flex: 1 0 1%;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    max-width: 468px;
    padding-top: 105px;

    @media (max-width: ${breakePoints.mobile}) {
        max-width: none;
        padding-top: 25px;
    }
`;

export const PreTitle = styled.h1`
    ${FONTS.H5};
    margin: 0;
    margin-bottom: 5px;
`;

export const Title = styled.div`
    ${FONTS.H1};

    & > i {
        display: contents;
        color: ${COLORS.RED_FIRM}
    }

    @media (max-width: ${breakePoints.laptop}) {
        margin-bottom: 8px;
        ${FONTS.H2};
    }

    @media (max-width: ${breakePoints.mobile}) {
        width: 250px;
    }
`;

export const Text = styled.div`
    ${FONTS.M};

    @media (max-width: ${breakePoints.tablet}) {
        ${FONTS.XS};
    }
`;

export const FormWrap = styled.div`
    width: 100%;
    margin-top: 18px;
`;
